import React from "react";
import {
    Box
} from '@chakra-ui/react';

const RawHtmlSlice = ({ slice }) => {
    console.log(slice);
    return (
        <Box dangerouslySetInnerHTML={{ __html: slice?.primary?.html_content?.richText }} />
    );
}

export default RawHtmlSlice;